import * as React from 'react';
import {Toggle as VWToggle} from '@volkswagen-onehub/components-core';
import {ToggleProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

export function Toggle({
  labelId,
  value,
  options,
  id,
  onChange,
  testId,
  disabled,
}: ToggleProps): JSX.Element {
  return (
    <VWToggle
      value={value}
      onChange={onChange}
      options={options}
      name={id}
      aria-describedby={labelId}
      data-testid={testId}
      disabled={disabled}
    />
  );
}
